import { useEffect, useState } from 'react';

const remainingSeconds = (target: number): number =>
  Math.max(0, Math.ceil((target - Date.now()) / 1000));

/** Whole seconds until `expiresAt`, ticking once a second; `null` without a target. */
export function useCountdown(expiresAt: string | null | undefined): number | null {
  const target = expiresAt ? Date.parse(expiresAt) : NaN;
  const [remaining, setRemaining] = useState<number | null>(() =>
    Number.isNaN(target) ? null : remainingSeconds(target)
  );

  useEffect(() => {
    if (Number.isNaN(target)) {
      setRemaining(null);
      return;
    }
    setRemaining(remainingSeconds(target));
    const id = setInterval(() => {
      const r = remainingSeconds(target);
      setRemaining(r);
      if (r <= 0) clearInterval(id);
    }, 1000);
    return () => clearInterval(id);
  }, [target]);

  return remaining;
}
